import classNames from 'classnames';
import { getName, getNeonBorderStyle } from 'domain/profil/Profil.func';
import React from 'react';

import { UserProfil } from '../../../../../domain/profil/UserProfil';
import { WrapperOtherProfilPhotoOverview } from '../../../User/WrapperOtherProfilPhotoOverview';

type ProfilPhotoProps = {
  profil: UserProfil;
  draftPhoto?: File;
};

export const ProfilPhoto = ({ profil, draftPhoto }: ProfilPhotoProps) => {
  const neonPhotoStyle = getNeonBorderStyle(profil.neonPhoto);

  return (
    <div className={'userProfilPhoto'}>
      <WrapperOtherProfilPhotoOverview
        size={'medium'}
        draftPhoto={draftPhoto}
        displayName={getName(profil)}
        photo={profil.publicPhotoUrl || profil.photo}
        idUser={profil.userId as number}
        className={classNames('photo')}
        style={neonPhotoStyle}
      />
    </div>
  );
};
